import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const MARGIN = 10;
const A4_W = 210;
const A4_H = 297;
const CONTENT_W = A4_W - MARGIN * 2;
const PAGE_CONTENT_H = A4_H - MARGIN * 2;
const PDF_WIDTH_PX = 800;
const CAPTURE_SCALE = 2;
// ponytail: fixed JPEG quality; raise if PDF text looks soft
const JPEG_QUALITY = 0.92;

const dateSlug = (completedAt, completedDate) => {
  if (completedAt) {
    const d = new Date(completedAt);
    if (!Number.isNaN(d.getTime())) return d.toISOString().slice(0, 10);
  }
  const d = new Date(completedDate);
  if (!Number.isNaN(d.getTime())) return d.toISOString().slice(0, 10);
  return new Date().toISOString().slice(0, 10);
};

const applyCaptureFixes = (doc) => {
  doc.querySelectorAll("[data-hra-pill]").forEach((el) => {
    el.style.display = "inline-flex";
    el.style.alignItems = "center";
    el.style.justifyContent = "center";
    el.style.lineHeight = "1";
    el.style.minHeight = "20px";
    el.style.paddingTop = "4px";
    el.style.paddingBottom = "4px";
    el.style.boxSizing = "border-box";
  });

  doc.querySelectorAll(".hra-wellness-center").forEach((el) => {
    el.style.display = "flex";
    el.style.flexDirection = "column";
    el.style.alignItems = "center";
    el.style.justifyContent = "center";
    el.style.gap = "4px";
  });

  doc.querySelectorAll(".hra-wellness-score").forEach((el) => {
    el.style.display = "block";
    el.style.lineHeight = "1";
  });

  doc.querySelectorAll(".hra-wellness-sub").forEach((el) => {
    el.style.display = "block";
    el.style.lineHeight = "1.2";
    el.style.marginTop = "4px";
  });
};

const addSliceToPdf = (pdf, sliceCanvas, pageIndex) => {
  const imgData = sliceCanvas.toDataURL("image/jpeg", JPEG_QUALITY);
  let imgWidth = CONTENT_W;
  let imgHeight = (sliceCanvas.height * imgWidth) / sliceCanvas.width;

  if (imgHeight > PAGE_CONTENT_H) {
    const scale = PAGE_CONTENT_H / imgHeight;
    imgWidth *= scale;
    imgHeight = PAGE_CONTENT_H;
  }

  const x = MARGIN + (CONTENT_W - imgWidth) / 2;
  const y = MARGIN + (PAGE_CONTENT_H - imgHeight) / 2;

  if (pageIndex > 0) pdf.addPage();
  pdf.addImage(imgData, "JPEG", x, y, imgWidth, imgHeight);
};

export async function downloadHraReportPdf(element, { completedAt, completedDate }) {
  const canvas = await html2canvas(element, {
    scale: CAPTURE_SCALE,
    useCORS: true,
    backgroundColor: "#ffffff",
    windowWidth: PDF_WIDTH_PX,
    onclone: (doc) => {
      const root = doc.getElementById("hra-report-print");
      if (root) {
        root.style.width = `${PDF_WIDTH_PX}px`;
        root.style.maxWidth = `${PDF_WIDTH_PX}px`;
      }

      doc.querySelectorAll("[data-pdf-hide]").forEach((el) => {
        el.style.display = "none";
      });

      applyCaptureFixes(doc);
    },
  });

  const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
  addSliceToPdf(pdf, canvas, 0);

  pdf.save(`HRA-Results-${dateSlug(completedAt, completedDate)}.pdf`);
}
